/**
 * Copyright 2016 xdot GmbH
 * Author: Marius Runde
 * Date: 02.06.2016
 *
 */
'use strict';

import React from 'external/react';
import PropTypes from 'external/prop-types';
import Map from '../components/Map';
import BoundingboxInputPlugin from '../plugins/BoundingboxInputPlugin';
import { Col, FormLabel, FormControl, FormGroup, Container, InputGroup, Row } from 'external/react-bootstrap';
import { ValidationMessage } from 'plugin/liferay-widgets-react-web';

class MapConfigDetails extends React.Component {

    constructor(props) {
        super(props);
        this.state = {};
    }

    getMetaData() {
        const { mapConfig } = this.props;

        return {
            title: mapConfig.title,
            description: mapConfig.description,
            centerLatitude: mapConfig.centerLatitude,
            centerLongitude: mapConfig.centerLongitude,
            zoom: mapConfig.zoom
        };
    }

    updateTitle(e) {
        let metaData = this.getMetaData();
        metaData.title = e.target.value;
        this.props.onChange(metaData);
    }

    updateDescription(e) {
        let metaData = this.getMetaData();
        metaData.description = e.target.value;
        this.props.onChange(metaData);
    }

    updateCenterLatitude(e) {
        let metaData = this.getMetaData();
        metaData.centerLatitude = parseFloat(e.target.value);
        this.props.onChange(metaData);
    }

    updateCenterLongitude(e) {
        let metaData = this.getMetaData();
        metaData.centerLongitude = parseFloat(e.target.value);
        this.props.onChange(metaData);
    }

    updateZoom(e) {
        let metaData = this.getMetaData();
        metaData.zoom = parseInt(e.target.value);
        this.props.onChange(metaData);
    }

    render() {
        const { mapConfig, formValidation } = this.props;
        const boundingBox = mapConfig.boundingBox || null;

        return (
            <Container>
                <Row>
                    <Col lg={6} md={6} sm={12} xs={12}>

                        <FormGroup controlId="formControlsMetaDataTitle">
                            <FormLabel>
                                Titel *
                            </FormLabel>
                            <FormControl type="text"
                                         required
                                         value={mapConfig.title || ''}
                                         onChange={this.updateTitle.bind(this)}
                            />
                            <ValidationMessage formValidation={formValidation} propName="title"/>
                        </FormGroup>

                        <FormGroup controlId="formControlsMetaDataDescription">
                            <FormLabel>
                                Beschreibung *
                            </FormLabel>
                            <FormControl as="textarea"
                                         required
                                         value={mapConfig.description || ''}
                                         onChange={this.updateDescription.bind(this)}
                            />
                            <ValidationMessage formValidation={formValidation} propName="description"/>
                        </FormGroup>

                    </Col>
                    <Col lg={6} md={6} sm={12} xs={12}>
                        <FormGroup controlId="formControlsMetaDataTitle">
                            <FormLabel>
                                BoundingBox *
                            </FormLabel>

                            <InputGroup type="hidden"
                                        name="latitudeMax"
                                        id="latitudeMax"
                                        required
                                        value={boundingBox && boundingBox.latitudeMax || undefined}/>

                            <InputGroup type="hidden"
                                        name="latitudeMin"
                                        id="latitudeMin"
                                        required
                                        value={boundingBox && boundingBox.latitudeMin || undefined}/>

                            <InputGroup type="hidden"
                                        name="longitudeMax"
                                        id="longitudeMax"
                                        required
                                        value={boundingBox && boundingBox.longitudeMax || undefined}/>

                            <InputGroup type="hidden"
                                        name="longitudeMin"
                                        id="longitudeMin"
                                        required
                                        value={boundingBox && boundingBox.longitudeMin || undefined}/>

                            <Map defaultFallbackMapConfigType={"static"}
                                 plugins={[ BoundingboxInputPlugin ]}
                                 boundingBox={boundingBox}
                                 onBoundingBoxChanged={this.props.onBoundingBoxChanged}/>
                            <ValidationMessage formValidation={formValidation} propName="boundingBox"/>
                        </FormGroup>


                    </Col>
                </Row>
            </Container>
        );
    }
}

MapConfigDetails.propTypes = {
    mapConfig: PropTypes.object,
    formValidation: PropTypes.object,
    onChange: PropTypes.func,
    onBoundingBoxChanged: PropTypes.func
};

export default MapConfigDetails;



// WEBPACK FOOTER //
// ./js/components/MapConfigDetails.jsx